import { env } from "@services/config/env";

/**
 * Resolves a service implementation based on the current API mode.
 *
 * @param realService  – The production implementation (calls the real API).
 * @param mockService  – The mock implementation (returns local data).
 * @returns The appropriate service for the current environment.
 *
 * @example
 * ```ts
 * const eventService = resolveService(realEventService, mockEventService);
 * ```
 */
export function resolveService<T>(realService: T, mockService: T): T {
  return env.apiMode === "production" ? realService : mockService;
}
